export default "__VITE_ASSET__d02c8be1__"